var _style, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadshotTipsFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "174px",
    height: "193px",
    viewBox: "0 0 174 193",
    style: {
      enableBackground: "new 0 0 174 193"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C343E;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{mask:url(#SVGID_1_);}\n\t.st4{opacity:0.46;fill-rule:evenodd;clip-rule:evenodd;fill:#D4DBE4;enable-background:new    ;}\n\t.st5{opacity:0.19;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#4AA033;}\n\t.st7{opacity:0.26;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1-4",
    className: "st0",
    d: "M26.4,12.9h132.2c8.4,0,15.2,6.8,15.2,15.2v149.6c0,8.4-6.8,15.2-15.2,15.2H26.4 c-8.4,0-15.2-6.8-15.2-15.2V28.1C11.1,19.7,17.9,12.9,26.4,12.9z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0.7,
    y: 35.3,
    width: 178.3,
    height: 193.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.7,
    y: 35.3,
    width: 178.3,
    height: 193.8,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-4_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1-4_1_",
    className: "st2",
    d: "M26.4,12.9h132.2c8.4,0,15.2,6.8,15.2,15.2v149.6c0,8.4-6.8,15.2-15.2,15.2H26.4 c-8.4,0-15.2-6.8-15.2-15.2V28.1C11.1,19.7,17.9,12.9,26.4,12.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st4",
    d: "M89.9,138.6c12.1,0,24.3,1.3,36.1,3.9c31.2,7,53,22.9,53,41.4c0,25-39.9,45.2-89.1,45.2 S0.7,208.8,0.7,183.8c0-7.7,3.8-14.9,10.4-21.2c10.3-9.8,27.4-17.4,48.1-21.3C69.3,139.5,79.6,138.6,89.9,138.6z M92,35.3 c21.9,0,39.6,19.3,39.6,43.2s-17.7,43.2-39.6,43.2s-39.6-19.3-39.6-43.2S70.1,35.3,92,35.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Path-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    d: "M90.1,139.5c36.5,0,63,15,79,44.8c0.7,1.3,0.2,2.9-1.1,3.6c-1.3,0.7-2.9,0.2-3.6-1.1 c-15.1-28.1-39.7-42-74.4-42s-57.6,13.9-69.7,41.8c-0.6,1.3-2.1,1.9-3.5,1.4c-1.3-0.6-1.9-2.1-1.4-3.4 C28.5,154.5,53.5,139.5,90.1,139.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3-2",
    d: "M90.1,139.5c36.5,0,63,15,79,44.8c0.7,1.3,0.2,2.9-1.1,3.6c-1.3,0.7-2.9,0.2-3.6-1.1 c-15.1-28.1-39.7-42-74.4-42s-57.6,13.9-69.7,41.8c-0.6,1.3-2.1,1.9-3.5,1.4c-1.3-0.6-1.9-2.1-1.4-3.4 C28.5,154.5,53.5,139.5,90.1,139.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-3-3",
    d: "M90.1,136.5c36.5,0,63,15,79,44.8c0.7,1.3,0.2,2.9-1.1,3.6c-1.3,0.7-2.9,0.2-3.6-1.1l0,0 c-15.1-28.1-39.7-42-74.4-42s-57.6,13.9-69.7,41.8c-0.6,1.3-2.1,1.9-3.5,1.4c-1.3-0.6-1.9-2.1-1.4-3.4 C28.5,151.5,53.5,136.5,90.1,136.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3-4",
    className: "st2",
    d: "M90.1,136.5c36.5,0,63,15,79,44.8c0.7,1.3,0.2,2.9-1.1,3.6c-1.3,0.7-2.9,0.2-3.6-1.1l0,0 c-15.1-28.1-39.7-42-74.4-42s-57.6,13.9-69.7,41.8c-0.6,1.3-2.1,1.9-3.5,1.4c-1.3-0.6-1.9-2.1-1.4-3.4 C28.5,151.5,53.5,136.5,90.1,136.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    d: "M92.1,25.2c-27,0-48.7,25.3-48.7,56.4S65.1,138,92.1,138s48.6-25.3,48.6-56.4S119.1,25.2,92.1,25.2z  M92.1,30.4c23.9,0,43.4,22.8,43.4,51.1s-19.5,51.1-43.4,51.1s-43.4-22.8-43.4-51.1S68.2,30.4,92.1,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5-2",
    d: "M92.1,25.2c-27,0-48.7,25.3-48.7,56.4S65.1,138,92.1,138s48.6-25.3,48.6-56.4S119.1,25.2,92.1,25.2z  M92.1,30.4c23.9,0,43.4,22.8,43.4,51.1s-19.5,51.1-43.4,51.1s-43.4-22.8-43.4-51.1S68.2,30.4,92.1,30.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-5-3",
    d: "M92.1,22.2c-27,0-48.7,25.3-48.7,56.4S65.1,135,92.1,135s48.6-25.3,48.6-56.4S119.1,22.2,92.1,22.2z  M92.1,27.4c23.9,0,43.4,22.8,43.4,51.1s-19.5,51.1-43.4,51.1s-43.4-22.8-43.4-51.1S68.2,27.4,92.1,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5-4",
    className: "st2",
    d: "M92.1,22.2c-27,0-48.7,25.3-48.7,56.4S65.1,135,92.1,135s48.6-25.3,48.6-56.4 S119.1,22.2,92.1,22.2z M92.1,27.4c23.9,0,43.4,22.8,43.4,51.1s-19.5,51.1-43.4,51.1s-43.4-22.8-43.4-51.1S68.2,27.4,92.1,27.4z "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "st6",
    d: "M34.8,17.2c0.2,9.3-7.2,17-16.5,17.2S1.4,27.2,1.2,18C1,8.7,8.4,1,17.7,0.8 C27,0.6,34.6,8,34.8,17.2C34.8,17.2,34.8,17.2,34.8,17.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "st7",
    d: "M4.3,19.9c-0.7,0-1.2-0.5-1.2-1.2C3,13.8,4.5,9.7,7.4,6.9s7-4.1,11.8-3.9c0.7,0,1.2,0.5,1.2,1.2 c0,0.7-0.5,1.2-1.2,1.2c-0.1,0-0.1,0-0.2,0c-4.2-0.2-7.6,0.9-10,3.2s-3.7,5.8-3.6,10.1C5.5,19.3,5,19.9,4.3,19.9L4.3,19.9z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.6,11.6c-0.8-0.4-1.7-0.2-2.1,0.6l-5.9,9.2l-3.1-3.1l-0.1-0.1c-0.6-0.5-1.5-0.5-2.1,0.1 c-0.6,0.6-0.6,1.6,0,2.2l4.4,4.5l0.1,0.1h0c0.2,0.3,0.6,0.5,1.1,0.5c0.6,0,1.1-0.4,1.2-0.9c0,0,0,0,0,0l7-10.8l0.1-0.1 C25.6,13,25.3,12,24.6,11.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadshotTipsFrame);
export default __webpack_public_path__ + "static/media/headshot-tips-frame.5eb1f0b89c99f6ab15e2135350d03016.svg";
export { ForwardRef as ReactComponent };